import React from 'react';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { SvgIcon } from '@gik/ui';
import { ScrollNavBar, ScrollNavItemsArray } from '@gik/ui';

export const pageSettingsScrollNavBarBlockName = 'page-settings-scroll-navbar';

export const pageSettingsNavItemIds = {
  title: 'title-section-id',
  features: 'features-section-id',
  privacy: 'privacy-section-id',
  recipient: 'recipient-section-id',
  organizers: 'organizers-section-id',
} as const;

export type PageSettingsNavItemIdsType = typeof pageSettingsNavItemIds[keyof typeof pageSettingsNavItemIds];

export interface IPageSettingsScrollNavBarProps {
  containerId?: string;
}

const PageSettingsScrollNavBar: React.FC<IPageSettingsScrollNavBarProps> = ({ containerId }): React.ReactElement => {
  const bem = bemBlock(pageSettingsScrollNavBarBlockName);
  const pageSettingsNavItems: ScrollNavItemsArray = [
    {
      variant: 'success',
      to: pageSettingsNavItemIds.title,
      icon: <SvgIcon name="InformationCircle" />,
      label: i18n.t(translationKeys.scrollNavTitle),
    },
    {
      variant: 'primary',
      to: pageSettingsNavItemIds.features,
      icon: <SvgIcon name="Features" set="gik-icons" />,
      label: i18n.t(translationKeys.scrollNavFeatures),
    },
    {
      variant: 'danger',
      to: pageSettingsNavItemIds.privacy,
      icon: <SvgIcon name="EyeOff" />,
      label: i18n.t(translationKeys.scrollNavPrivacy),
    },
    {
      variant: 'purple',
      to: pageSettingsNavItemIds.recipient,
      icon: <SvgIcon name="User" />,
      label: i18n.t(translationKeys.scrollNavRecipient),
    },
    {
      variant: 'secondary',
      to: pageSettingsNavItemIds.organizers,
      icon: <SvgIcon name="Users" />,
      label: i18n.t(translationKeys.scrollNavOrganizers),
    },
  ];

  return <ScrollNavBar containerId={containerId} navItems={pageSettingsNavItems} className={bem()} />;
};

export default PageSettingsScrollNavBar;
